import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px 20px;
  
  @media (max-width: 768px) {
    padding: 30px 15px 15px;
  }
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #ecf0f1;
  }
  
  p {
    font-size: 14px;
    line-height: 1.6;
    color: #bdc3c7;
    margin-bottom: 10px;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FooterLink = styled.button`
  background: none;
  border: none;
  color: #bdc3c7;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  padding: 4px 0;
  transition: color 0.2s ease;
  
  &:hover {
    color: #ecf0f1;
  }
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #95a5a6;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
`;

const FooterBottomLinks = styled.div`
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    gap: 15px;
  }
`;

const FooterBottomLink = styled.button`
  background: none;
  border: none;
  color: #95a5a6;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: #ecf0f1;
  }
`;

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path: string) => {
    navigate(path);
  };

  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterGrid>
          <FooterSection>
            <h3>About Infonium</h3>
            <p>
              Infonium is a modern information platform providing high-quality news and content 
              with optimal user experience. We are committed to delivering accurate, timely, 
              and useful information.
            </p>
            <p>
              <strong>Contact:</strong> <a href="mailto:contact@infonium.org" style={{ color: '#bdc3c7', textDecoration: 'none' }}>contact@infonium.org</a>
            </p>
          </FooterSection>

          <FooterSection>
            <h3>Support</h3>
            <FooterLinks>
              <FooterLink onClick={() => handleLinkClick('/contact')}>
                Contact
              </FooterLink>
            </FooterLinks>
          </FooterSection>

          <FooterSection>
            <h3>Legal</h3>
            <FooterLinks>
              <FooterLink onClick={() => handleLinkClick('/terms')}>
                Terms of Service
              </FooterLink>
              <FooterLink onClick={() => handleLinkClick('/privacy')}>
                Privacy Policy
              </FooterLink>
            </FooterLinks>
          </FooterSection>
        </FooterGrid>

        <FooterBottom>
          <div>
            © {currentYear} Infonium. All rights reserved.
          </div>
          <FooterBottomLinks>
            <FooterBottomLink onClick={() => handleLinkClick('/privacy')}>
              Privacy
            </FooterBottomLink>
            <FooterBottomLink onClick={() => handleLinkClick('/terms')}>
              Terms
            </FooterBottomLink>
          </FooterBottomLinks>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 